"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonI18N = void 0;

var _commonI18n = _interopRequireDefault(require("./components/common-i18n"));

exports.CommonI18N = _commonI18n["default"];